import { toAbsoluteUrl } from "../../_metronic/helpers";

interface TierTypes {
  [key: number]: {
    icon: JSX.Element;
    type: string;
  };
}

export const usageTierTypes: TierTypes = {
  1: {
    icon: (
      <img src={toAbsoluteUrl("/media/usage_icons/tier1.png")} alt="Tier 1" />
    ),
    type: "Bronze",
  },
  2: {
    icon: (
      <img src={toAbsoluteUrl("/media/usage_icons/tier2.png")} alt="Tier 2" />
    ),
    type: "Silver",
  },
  3: {
    icon: (
      <img src={toAbsoluteUrl("/media/usage_icons/tier3.png")} alt="Tier 3" />
    ),
    type: "Gold",
  },
  4: {
    icon: (
      <img src={toAbsoluteUrl("/media/usage_icons/tier4.png")} alt="Tier 4" />
    ),
    type: "Titanium",
  },
  5: {
    icon: (
      <img src={toAbsoluteUrl("/media/usage_icons/tier5.png")} alt="Tier 5" />
    ),
    type: "Platinum",
  },
};
